'use client';

import { useTranslations } from 'next-intl';
import BaseSidebarLayout from '@/components/common/BaseSidebarLayout';
import { useParams } from 'next/navigation';

type Props = {
    children: React.ReactNode;
};

export default function CompanyLayout({ children }: Props) {
    const params = useParams();
    const locale = params.locale as string;
    const t = useTranslations('CompanyPage');

    const menuItems = [
        { id: 'about-us', label: t('aboutUs'), href: `/${locale}/company/about-us` },
        { id: 'company-news', label: t('companyNews'), href: `/${locale}/company/news` },
    ];

    return <BaseSidebarLayout menuItems={menuItems} title={t('title')}>{children}</BaseSidebarLayout>;
}
